export default __webpack_public_path__ + "static/media/fiolet_googleplay.2647d0ce.svg";